import React from 'react';

import {
  ScalingContext,
  ScalingContextProvider,
} from 'components/ResponsiveLayout';
import * as roleProps from 'cross-platform/utils/roleProps';
import { ErrorBoundary } from 'lib/error/ErrorBoundary/ErrorBoundary';
import { addStory } from 'lib/story-books';

import { ThrowButton } from './components/ThrowButton';
import { useThrowingErroringApi } from './utils/useThrowingErroringApi';

export const OnRecoverSetStory = (): React.ReactElement => {
  const { throwing, erroring } = useThrowingErroringApi();
  return (
    <ScalingContextProvider scalingContext={ScalingContext.ContentScreen}>
      <ErrorBoundary
        onRecover={() => {
          // handleAction
          console.log('Recover!');
          // Custom behavior to (hopefully) reset the situation, so there is no error
          erroring.setErrorDetails(undefined);
          throwing.setIsThrow(false); // Recover
        }}
        onError={error => {
          erroring.setErrorDetails({
            error,
          });
        }}
      >
        <ThrowButton
          {...roleProps.roles('ThrowButton')}
          api={throwing}
          text="Recoverable error"
        />
      </ErrorBoundary>
    </ScalingContextProvider>
  );
};

addStory('error-handling/onRecover/set', OnRecoverSetStory);

export const OnRecoverNotSetStory = (): React.ReactElement => {
  const { throwing, erroring } = useThrowingErroringApi();
  return (
    <ErrorBoundary
      onRecover={
        // No custom behavior to (hopefully) reset the situation, so there is no error
        undefined
      }
      onError={error => {
        erroring.setErrorDetails({
          error,
        });
      }}
    >
      <ThrowButton api={throwing} text="Non-recoverable error" />
    </ErrorBoundary>
  );
};
addStory('error-handling/onRecover/not-set', OnRecoverNotSetStory);
